/**
 * Defines the available toolbar designs.
 * @public
 * @since 2.0.0
 */
enum ToolbarDesign {
    /**
	 * The toolbar and its content will be displayed with solid background.
	 * @public
	 */
	Solid = "Solid",

	/**
	 * The toolbar and its content will be displayed with transparent background.
	 * @public
	 */
	Transparent = "Transparent",
}

export default ToolbarDesign;
